
// import React, { forwardRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { auth } from "./firebase_config";
// import { 
//   FaUser, FaCut, FaFileInvoice, FaEdit, 
//   FaClipboardCheck, FaTrash, FaSignOutAlt 
// } from "react-icons/fa";
// import { 
//   getFirestore, collection, getDocs 
// } from "firebase/firestore";
// import * as XLSX from "xlsx"; // Import XLSX for Excel generation
// import "./sidebar.css";


// const Sidebar = forwardRef(({ uid, name, isAdmin }, ref) => {
//   const navigate = useNavigate();
//   const firestore = getFirestore();

//   // Logout handler
//   const handleLogout = async () => {
//     await auth.signOut();
//     navigate("/");
//   };

//   // Function to fetch mess cuts for all departments and export to Excel
//   const fetchMessCutsForAllDepartments = async () => {
//     try {
//       const usersCollection = collection(firestore, 'sahrudaya_mess');
//       const querySnapshot = await getDocs(usersCollection);

//       const messCutsData = querySnapshot.docs.map((doc) => ({
//         Department: doc.data().department || "Unknown",
//         Name: doc.data().name,
//         MessNumber: doc.data().messNo || "N/A",
//         MessCuts: doc.data().messCuts
//           ? doc.data().messCuts.map((cut) => cut.dates.join(", ")).join("; ")
//           : "No Cuts",
//       }));


//       // Generate Excel sheet
//       const worksheet = XLSX.utils.json_to_sheet(messCutsData); // Convert data to worksheet
//       const workbook = XLSX.utils.book_new(); // Create a new workbook
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Mess Cuts"); // Add sheet to workbook
//       XLSX.writeFile(workbook, `MessCuts_AllDepartments.xlsx`); // Save workbook as file

//       alert(`Mess cuts for all departments exported successfully.`);
//     } catch (error) {
//       console.error("Error fetching mess cuts: ", error);
//       alert("Failed to fetch and export mess cuts. Please try again.");
//     }
//   };
//   const exportBillDetails = async () => {
//     try {
//       const firestore = getFirestore();
//       const usersCollection = collection(firestore, 'sahrudaya_mess');
//       const querySnapshot = await getDocs(usersCollection);
  
//       const billData = querySnapshot.docs.map((doc) => {
//         const billAmountMap = doc.data().billAmount || {};
  
//         const latestDate = Object.keys(billAmountMap).sort().pop();
//         const billAmount = billAmountMap[latestDate] || {};
 
  
//         return {
//           Name: doc.data().name || "",
//           MessNo:doc.data().messNo|| "",
//           ActiveDays: billAmount.activeDays || 0,

//           // Amount: billAmount.amount || 0,
//           Establishment: billAmount.establishment || 0,
//           PerDayAmount: billAmount.perDayAmount || 0,
//           MessCutAmount: billAmount.messCutAmount || 0,
//           Others: billAmount.others || 0,
//           SpecialFees: billAmount.specialFees || 0,
//           Deductions: billAmount.deductions || 0,
//           Fine: billAmount.fine || 0,
//           FinalAmount: billAmount.finalAmount || 0,
//         };
//       });
  
//       const worksheet = XLSX.utils.json_to_sheet(billData); 
//       const workbook = XLSX.utils.book_new(); 
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Bill Details"); 
//       XLSX.writeFile(workbook, `BillDetails_AllUsers.xlsx`);
  
//       alert(`Bill details exported successfully.`);
//     } catch (error) {
//       console.error("Error exporting bill details: ", error);
//       alert("Failed to export bill details. Please try again.");
//     }
//   };

//   return (
//     <div className="sidebar" ref={ref}>
//       <h2>Welcome, {name}!</h2>
//       <ul>
//         <li>
//           <Link to="/profile">
//             <FaUser /> Profile
//           </Link>
//         </li>
//         {(isAdmin || uid === "MEOsv8ClQAa3lT4odkEGSdKOn963") && (
//           <li>
//             <Link to="/mealattendance">
//               <FaClipboardCheck /> Mark Attendance
//             </Link>
//           </li>
//         )}
//         <li>
//           <Link to={`/messcut/${uid}`}>
//             <FaCut /> Mess Cut
//           </Link>
//         </li>
//         {uid === "MEOsv8ClQAa3lT4odkEGSdKOn963" && (
//           <>
//             <li>
//               <Link to={`/allusers/${uid}`}>
//                 <FaUser /> All Users
//               </Link>
//             </li>
//             <li>
//               <Link to={`/generatebill/${uid}`}>
//                 <FaEdit /> Generate Bill
//               </Link>
//             </li>
//             <div className="row">
//               <li>
//                 <button
//                   onClick={exportBillDetails}
//                   className="admin-action-button"
//                 >
//                   Export Bill Amounts
//                 </button>
//               </li>
//               <li>
//                 <button
//                   onClick={fetchMessCutsForAllDepartments}
//                   className="admin-action-button"
//                 >
//                   Export MessCuts
//                 </button>
//               </li>
//             </div>
//           </>
//         )}
//         <li>
//           <Link to={`/bill/${uid}`}>
//             <FaFileInvoice /> Bill
//           </Link>
//         </li>
//       </ul>
//       <button onClick={handleLogout} className="logout-button">
//         <FaSignOutAlt /> Logout
//       </button>
//     </div>
//   );
// });

// export default Sidebar;
//delete bill amount 


// // // import React, { forwardRef } from "react";
// // // import { Link, useNavigate } from "react-router-dom";
// // // import { auth } from "./firebase_config";
// // // import { FaUser, FaCut, FaFileInvoice, FaEdit, FaClipboardCheck, FaTrash, FaSignOutAlt } from "react-icons/fa";
// // // import { getFirestore, collection, getDocs, updateDoc, doc, deleteField } from "firebase/firestore";
// // // import "./sidebar.css";

// // // const Sidebar = forwardRef(({ uid, name, isAdmin }, ref) => {
// // //   const navigate = useNavigate();
// // //   const firestore = getFirestore();

// // //   // Logout handler
// // //   const handleLogout = async () => {
// // //     await auth.signOut();
// // //     navigate("/");
// // //   };

// // //   // Function to delete `billAmount` map for all users
// // //   const deleteBillAmountForAllUsers = async () => {
// // //     try {
// // //       const usersCollection = collection(firestore, "users");
// // //       const querySnapshot = await getDocs(usersCollection);

// // //       // Iterate through each user and delete the `billAmount` field
// // //       const deletePromises = querySnapshot.docs.map((userDoc) =>
// // //         updateDoc(doc(firestore, "users", userDoc.id), {
// // //           billAmount: deleteField(),
// // //         })
// // //       );

// // //       await Promise.all(deletePromises);

// // //       alert("Successfully deleted the `billAmount` field for all users.");
// // //     } catch (error) {
// // //       console.error("Error deleting `billAmount` field: ", error);
// // //       alert("Failed to delete `billAmount` field. Please try again.");
// // //     }
// // //   };

// // //   return (
// // //     <div className="sidebar" ref={ref}>
// // //       <h2>Welcome, {name}!</h2>
// // //       <ul>
// // //         <li>
// // //           <Link to="/profile">
// // //             <FaUser /> Profile
// // //           </Link>
// // //         </li>
// // //         {(isAdmin || uid === "5GyeJfaXn5MHvCu11RMNXCWDBnB3") && (
// // //           <li>
// // //             <Link to="/mealattendance">
// // //               <FaClipboardCheck /> Mark Attendance
// // //             </Link>
// // //           </li>
// // //         )}
// // //         <li>
// // //           <Link to={`/messcut/${uid}`}>
// // //             <FaCut /> Mess Cut
// // //           </Link>
// // //         </li>
// // //         {uid === "5GyeJfaXn5MHvCu11RMNXCWDBnB3" && (
// // //           <>
// // //             <li>
// // //               <Link to={`/allusers/${uid}`}>
// // //                 <FaUser /> All Users
// // //               </Link>
// // //             </li>
// // //             <li>
// // //               <Link to={`/generatebill/${uid}`}>
// // //                 <FaEdit /> Generate Bill
// // //               </Link>
// // //             </li>
// // //               {/* Admin-only button to delete `billAmount` */}
// // //               <li>
// // //               <button
// // //                 onClick={deleteBillAmountForAllUsers}
// // //                 className="admin-action-button "
// // //               >
// // //            Delete Bill
// // //               </button>
// // //             </li>

// // //           </>
// // //         )}
// // //         <li>
// // //           <Link to={`/bill/${uid}`}>
// // //             <FaFileInvoice /> Bill
// // //           </Link>
// // //         </li>
        
// // //       </ul>
// // //       <button onClick={handleLogout} className="logout-button">
// // //       <FaSignOutAlt /> Logout
// // //       </button>
// // //     </div>
// // //   );
// // // });

// // // export default Sidebar;
  
// for each dept 



// import React, { forwardRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { auth } from "./firebase_config";
// import { 
//   FaUser, FaCut, FaFileInvoice, FaEdit, 
//   FaClipboardCheck, FaTrash, FaSignOutAlt 
// } from "react-icons/fa";
// import { 
//   getFirestore, collection, getDocs, query, where 
// } from "firebase/firestore";
// import * as XLSX from "xlsx"; // Import XLSX for Excel generation
// import "./sidebar.css";

// const Sidebar = forwardRef(({ uid, name, isAdmin }, ref) => {
//   const navigate = useNavigate();
//   const firestore = getFirestore();

//   // Logout handler
//   const handleLogout = async () => {
//     await auth.signOut();
//     navigate("/");
//   };

//   // Function to fetch mess cuts by department and export to Excel
//   const fetchMessCutsByDepartment = async () => {
//     const department = "DUK"; // Replace with a dynamic department if needed

//     try {
//       const usersCollection = collection(firestore, "users");
//       const departmentQuery = query(usersCollection, where("department", "==", department));
//       const querySnapshot = await getDocs(departmentQuery);

//       const messCutsData = querySnapshot.docs.map((doc) => ({
//         Name: doc.data().name,
//         MessNumber: doc.data().messNo || "N/A", // Ensure messNumber exists in Firestore
//         MessCuts: doc.data().messCuts
//           ? doc.data().messCuts.map((cut) => cut.dates.join(", ")).join("; ")
//           : "No Cuts",
//       }));

//       // Generate Excel sheet
//       const worksheet = XLSX.utils.json_to_sheet(messCutsData); // Convert data to worksheet
//       const workbook = XLSX.utils.book_new(); // Create a new workbook
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Mess Cuts"); // Add sheet to workbook
//       XLSX.writeFile(workbook, `MessCuts_${department}.xlsx`); // Save workbook as file

//       alert(`Mess cuts for department ${department} exported successfully.`);
//     } catch (error) {
//       console.error("Error fetching mess cuts: ", error);
//       alert("Failed to fetch and export mess cuts. Please try again.");
//     }
//   };

//   return (
//     <div className="sidebar" ref={ref}>
//       <h2>Welcome, {name}!</h2>
//       <ul>
//         <li>
//           <Link to="/profile">
//             <FaUser /> Profile
//           </Link>
//         </li>
//         {(isAdmin || uid === "5GyeJfaXn5MHvCu11RMNXCWDBnB3") && (
//           <li>
//             <Link to="/mealattendance">
//               <FaClipboardCheck /> Mark Attendance
//             </Link>
//           </li>
//         )}
//         <li>
//           <Link to={`/messcut/${uid}`}>
//             <FaCut /> Mess Cut
//           </Link>
//         </li>
//         {uid === "5GyeJfaXn5MHvCu11RMNXCWDBnB3" && (
//           <>
//             <li>
//               <Link to={`/allusers/${uid}`}>
//                 <FaUser /> All Users
//               </Link>
//             </li>
//             <li>
//               <Link to={`/generatebill/${uid}`}>
//                 <FaEdit /> Generate Bill
//               </Link>
//             </li>
            
//             <li>
//               <button
//                 onClick={fetchMessCutsByDepartment}
//                 className="admin-action-button"
//               >
//                 Fetch MessCuts by Department
//               </button>
//             </li>
//           </>
//         )}
//         <li>
//           <Link to={`/bill/${uid}`}>
//             <FaFileInvoice /> Bill
//           </Link>
//         </li>
//       </ul>
//       <button onClick={handleLogout} className="logout-button">
//         <FaSignOutAlt /> Logout
//       </button>
//     </div>
//   );
// });

// export default Sidebar;

// for all dept 


import React, { useState, forwardRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "./firebase_config";
import { 
  FaUser, FaCut, FaFileInvoice, FaEdit, 
  FaClipboardCheck, FaTrash, FaSignOutAlt 
} from "react-icons/fa";
import { 
  getFirestore, collection, getDocs 
} from "firebase/firestore";
import * as XLSX from "xlsx"; // Import XLSX for Excel generation
import "./sidebar.css";

const Sidebar = forwardRef(({ uid, name, isAdmin }, ref) => {
  const navigate = useNavigate();
  const firestore = getFirestore();

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");

  // Logout handler
  const handleLogout = async () => {
    await auth.signOut();
    navigate("/");
  };

  // Function to fetch mess cuts for all departments and export to Excel
  const fetchMessCutsForAllDepartments = async () => {
    try {
      const usersCollection = collection(firestore,  'sahrudaya_mess');
      const querySnapshot = await getDocs(usersCollection);

      const messCutsData = querySnapshot.docs.map((doc) => ({
        Department: doc.data().department || "Unknown",
        Name: doc.data().name,
        MessNumber: doc.data().messNo || "N/A",
        MessCuts: doc.data().messCuts
          ? doc.data().messCuts.map((cut) => cut.dates.join(", ")).join("; ")
          : "No Cuts",
      }));

      // Generate Excel sheet
      const worksheet = XLSX.utils.json_to_sheet(messCutsData); // Convert data to worksheet
      const workbook = XLSX.utils.book_new(); // Create a new workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Mess Cuts"); // Add sheet to workbook
      XLSX.writeFile(workbook, `MessCuts_AllDepartments.xlsx`); // Save workbook as file

      alert(`Mess cuts for all departments exported successfully.`);
    } catch (error) {
      console.error("Error fetching mess cuts: ", error);
      alert("Failed to fetch and export mess cuts. Please try again.");
    }
  };
  // seperate dept
  const fetchMessCuts = async () => {
    try {
      const usersCollection = collection(firestore,  'sahrudaya_mess');
      const querySnapshot = await getDocs(usersCollection);

      const filteredMessCutsData = querySnapshot.docs
        .map((doc) => {
          const userData = doc.data();
          const department = userData.department || "Unknown";
          const messCuts = userData.messCuts || [];

          if (selectedDepartment && department !== selectedDepartment) return null;

          const filteredCuts = messCuts.filter((cut) => cut.dates.some((date) => date.includes(`-${selectedMonth}-`)));

          return filteredCuts.length > 0
            ? {
                Department: department,
                Name: userData.name,
                MessNumber: userData.messNo || "N/A",
                MessCuts: filteredCuts.map((cut) => cut.dates.join(", ")).join("; "),
              }
            : null;
        })
        .filter((item) => item !== null);

      if (filteredMessCutsData.length === 0) {
        alert("No mess cuts found for the selected month and department.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(filteredMessCutsData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Mess Cuts");
      XLSX.writeFile(workbook, `MessCuts_${selectedDepartment}_${selectedMonth}.xlsx`);

      alert(`Mess cuts for ${selectedDepartment} in ${selectedMonth} exported successfully.`);
    } catch (error) {
      console.error("Error fetching mess cuts: ", error);
      alert("Failed to fetch and export mess cuts. Please try again.");
    }
  };

  const exportBillDetails = async () => {
    try {
      const firestore = getFirestore();
      const usersCollection = collection(firestore, 'sahrudaya_mess');
      const querySnapshot = await getDocs(usersCollection);
  
      const billData = querySnapshot.docs.map((doc) => {
        const billAmountMap = doc.data().billAmount || {};
  
        const latestDate = Object.keys(billAmountMap).sort().pop();
        const billAmount = billAmountMap[latestDate] || {};
 
  
        return {
          Name: doc.data().name || "",
          
          ActiveDays: billAmount.activeDays || 0,
          MessNo:doc.data().messNo|| "",
          // Amount: billAmount.amount || 0,
          Establishment: billAmount.establishment || 0,
          PerDayAmount: billAmount.perDayAmount || 0,
          MessCutAmount: billAmount.messCutAmount || 0,
          Others: billAmount.others || 0,
          SpecialFees: billAmount.specialFees || 0,
          Deductions: billAmount.deductions || 0,
          Fine: billAmount.fine || 0,
          FinalAmount: billAmount.finalAmount || 0,
        };
      });
  
      const worksheet = XLSX.utils.json_to_sheet(billData); 
      const workbook = XLSX.utils.book_new(); 
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bill Details"); 
      XLSX.writeFile(workbook, `BillDetails_AllUsers.xlsx`);
  
      alert(`Bill details exported successfully.`);
    } catch (error) {
      console.error("Error exporting bill details: ", error);
      alert("Failed to export bill details. Please try again.");
    }
  };


  return (
    <div className="sidebar" ref={ref}>
      <h2>Welcome, {name}!</h2>
      <ul>
        <li>
          <Link to="/profile">
            <FaUser /> Profile
          </Link>
        </li>
        {(isAdmin || uid === "MEOsv8ClQAa3lT4odkEGSdKOn963") && (
          <li>
            <Link to="/mealattendance">
              <FaClipboardCheck /> Mark Attendance
            </Link>
          </li>
        )}
        <li>
          <Link to={`/messcut/${uid}`}>
            <FaCut /> Mess Cut
          </Link>
        </li>
        <li>
          <Link to={`/bill/${uid}`}>
            <FaFileInvoice /> Bill
          </Link>
        </li>
        
        {uid === "MEOsv8ClQAa3lT4odkEGSdKOn963" && (
          <>
            <li>
              <Link to={`/allusers/${uid}`}>
                <FaUser /> All Users
              </Link>
            </li>
            <li>
              <Link to={`/generatebill/${uid}`}>
                <FaEdit /> Generate Bill
              </Link>
            </li>
         
            <div className="row">
              <li>
                <button
                  onClick={exportBillDetails}
                  className="admin-action-button"
                >
                  Export Bill Amounts
                </button>
              </li>
               <li>
                <button
                  onClick={fetchMessCutsForAllDepartments}
                  className="admin-action-button"
                >
                  Export All MessCuts
                </button>
              </li>
              </div>
             
              <div className="filter-section">
              <label>Month:</label>
              <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                <option value="">Select Month</option>
                {Array.from({ length: 12 }, (_, i) => {
                  const month = (i + 1).toString().padStart(2, "0");
                  return <option key={month} value={month}>{month}</option>;
                })}
              </select>
              <label>Department:</label>
              <input type="text" value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)} placeholder="Enter Dept" />
            
            </div>
            <button onClick={fetchMessCuts} className="export1button">Export MessCuts</button>
        
          </>
        )}
     
    
      </ul>
      <button onClick={handleLogout} className="logout-button">
        <FaSignOutAlt /> Logout
      </button>
    </div>
  );
});

export default Sidebar;
